<template>
    <v-container v-if="['PILOT', 'PILOT_UFBB'].includes(assignment.type)">
        <form-toolbar :userRoles="userRoles" :canEdit="canEdit" :editMode="editMode" :assignment="assignment" :field="'autopsy'" @cancel-button-clicked="switchEditMode(false)" @edit-button-clicked="switchEditMode(true)"/>
        <v-form :readonly="readOnly" class="assignment-form">
            <v-card class = "form-group-fields" elevation="6">
                <div class="first-row-wrapper">
                    <custom-datetime :value="localAutopsy.appointmentDate || ''" :readOnly="true"  @onSelect="appointmentDateSelected"/>
                    <custom-checkbox
                        :readOnly="readOnly"
                        :label="'Smart Readiness'"
                        :color="'blue'"
                        change-back
                        :value="!!this.smartReadiness"
                        @check-value-change="onSmartReadinessChange"
                    />
                    <custom-checkbox
                        :readOnly="readOnly"
                        :label="'Πρώτη φορά Smart Readiness'"
                        :color="'blue'"
                        change-back
                        :disabled="!this.smartReadiness"
                        :value="!!!this.secondTimeSmartReadiness"
                        @check-value-change="onSecondTimeSmartReadinessChange"
                    />
                </div>
                <div class="first-row-wrapper">
                    <div class="pdf-file-input">
                        <v-file-input
                            v-model="pdfFile"
                            accept="application/pdf"
                            placeholder="Ανέβασμα PDF Αυτοψίας"
                            label="Ανέβασμα PDF Αυτοψίας"
                            prepend-icon="mdi-file-pdf-box"
                            :disabled="!editMode"
                        >
                            <template v-slot:selection="{ text }">
                                <v-chip
                                    small
                                    label
                                    color="primary"
                                >
                                    {{ text }}
                                </v-chip>
                            </template>
                        </v-file-input>
                    </div>
                    <div class="prodesmeusi-file-input">
                        <v-btn v-if="localAutopsy.materials?.prodesmeusiFile" class="download-icon" @click="downloadFile(localAutopsy.materials.prodesmeusiFile)" fab small>
                            <v-icon color="blue" large >mdi-download</v-icon>
                        </v-btn>
                        <v-file-input
                            v-model="prodesmeusiFile"
                            accept="text/xlsx, .xlsx"
                            placeholder="Ανέβασμα Excel Προδέσμευσης"
                            label="Ανέβασμα Excel Προδέσμευσης"
                            prepend-icon=""
                            :disabled="!editMode"
                        >
                            <template v-slot:selection="{ text }">
                                <v-chip
                                    small
                                    label
                                    color="primary"
                                >
                                    {{ text }}
                                </v-chip>
                            </template>
                            <template v-slot:prepend-inner>
                                <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-paperclip</v-icon>
                            </template>
                        </v-file-input>
                        <v-btn v-if="this.prodesmeusiFile" class="upload-icon" @click="uploadProdesmeusiFile()" :loading="uploadLoader" fab small>
                            <v-icon color="blue" large >mdi-upload</v-icon>
                        </v-btn>
                    </div>
                </div>
                <div class="second-row-wrapper">
                    <v-select
                        v-model="clientFloor"
                        :items="availableFloors"
                        label="Όροφος Πελάτη"
                        outlined
                        :clearable="clearable"
                        :disabled="shouldRestFieldsBeDisabled"
                        class="field client-floor"
                    ></v-select>
                    <v-dialog
                        v-model="dialog"
                        width="500"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="white--text button-to-display"
                                large
                                :color="'black'"
                                :disabled="!localAutopsy.floorStructure"
                                :depressed="editMode">
                                <span>Δομη Κτιριου</span>
                                <!-- <span v-else>Ορισμος Δομης Κτιριου</span> -->
                            </v-btn>
                        </template>
                        <floor-structure :editMode="false" :stored="this.localAutopsy.floorStructure" @floorStructureUpdate="onFloorStructureSubmit"/>
                    </v-dialog>
                    <v-dialog
                        v-model="dialog3"
                        width="700"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="white--text button-to-display"
                                large
                                :color="'black'"
                                :disabled="!localAutopsy.materials"
                                :depressed="editMode">
                                <span>Υλικα</span>
                                <!-- <span v-else>Ορισμος Δομης Κτιριου</span> -->
                            </v-btn>
                        </template>
                        <prodesmeusi-materials :prodesmeusiMaterials="localAutopsy.materials"/>
                    </v-dialog>
                    <v-dialog
                        v-model="dialog2"
                        width="700"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="white--text button-to-display"
                                large
                                :color="'black'"
                                :disabled="!localAutopsy.opticalPath"
                                :depressed="editMode">
                                <span>Optical Path</span>
                                <!-- <span v-else>Ορισμος Δομης Κτιριου</span> -->
                            </v-btn>
                        </template>
                        <optical-path :opticalPath="localAutopsy.opticalPath"/>
                    </v-dialog>
                    <pdf-viewer class="button-to-display" :pdfUrl="pdfUrl" :disabled="!localAutopsy.pdfFileUrl" :title="'Αυτοψίας'" />
                </div>
                <div class="first-row-wrapper">
                    <v-select
                        v-model="localAutopsy.status"
                        :items="statuses"
                        item-value="value"
                        item-text="name"
                        label="Κατάσταση"
                        outlined
                        class="field status"
                        :disabled="!editMode || shouldRestFieldsBeDisabled"
                    ></v-select>
                    <v-select
                        v-model="localAutopsy.subStatus"
                        :items="subStatuses"
                        item-value="value"
                        item-text="name"
                        label="Αποτέλεσμα"
                        outlined
                        :disabled="disableSubStatus || !editMode || shouldRestFieldsBeDisabled"
                        class="field status"
                    ></v-select>
                </div>
                <comments
                    ref="comments"
                    class="mt-1"
                    :comments="this.localAutopsy?.comments || {}"
                    :clearable="clearable"
                    :editMode="editMode"
                    :rules="editMode && (localAutopsy.status || this.isCancelled) ? rules: []"
                    @new-comment="onNewComment"
                />
                <image-section ref="image-section" :uploadedPhotos="this.localAutopsy.photos || []" :editMode="editMode" :readOnly="readOnly" :clearable="clearable" :uploadPath="this.assignment.sr + '/autopsy/photos'" @photoSelection="onPhotoSelection" :zipName="this.assignment.sr + '_' + 'photos' + '_' + 'autopsy'"/>
                <file-section ref="file-section" :label="'Ανέβασμα Αρχείων'" :title="'Αρχεία'" :alreadyUploadedFiles="this.localAutopsy.files || []" :editMode="editMode" :readOnly="readOnly" :clearable="clearable" :folderPath="this.assignment.sr + '/autopsy'" :zipName="this.assignment.sr + '_' + 'files' + '_' + 'autopsy'"/>

                <v-text-field
                    v-model="videoUrl"
                    class="my-2"
                    label="URL Video"
                    prepend-icon=""
                    :readonly="readOnly"
                    :clearable="clearable"
                    :append-icon="this.videoUrl ? 'mdi-open-in-new' :''"
                    @click:append="onVideoOpenClick"
                >
                    <template v-slot:prepend-inner>
                        <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-video</v-icon>
                    </template>
                </v-text-field>
                <div v-if="!shouldRestFieldsBeDisabled" class="comments-row-wrapper">
                    <div class="comments-selections-earthwork">
                        <h4>Χωματουργικά</h4>
                        <v-select
                            v-model="commentsForConstruction.earthwork.option"
                            :items="earthworkOptions"
                            item-value="value"
                            item-text="name"
                            label="Είδος Χωματουργικών"
                            outlined
                            class="field status"
                        ></v-select>
                        <div v-if="commentsForConstruction?.earthwork?.option !== 'COMPLETED'" class="rating-wrapper">
                            <span class="rating-text">
                                Βαθμονόμιση Δυσκολίας
                            </span>
                            <v-rating
                                v-model="commentsForConstruction.earthwork.rating"
                                class="rating"
                                :readonly="readOnly"
                                :clearable="!readOnly"
                            >
                                <template v-slot:item="props">
                                    <div class="rating-icon-wrapper">
                                        <v-icon
                                            :color="props.isFilled ? hardnessColors[props.index] : 'grey lighten-1'"
                                            large
                                            class="rating-icon"
                                            @click="props.click"
                                        >
                                            {{ props.isFilled ? 'mdi-star-circle' : 'mdi-star-circle-outline' }}
                                        </v-icon>
                                        <span v-if="props.index === 0" class="rating-text">
                                            Έυκολο
                                        </span>
                                        <span v-if="props.index === hardnessColors.length - 1" class="rating-text">
                                            Δύσκολο
                                        </span>
                                    </div>
                                </template>
                            </v-rating>
                        </div>
                    </div>
                    <v-textarea
                        v-if="commentsForConstruction?.earthwork?.option !== 'COMPLETED'"
                        v-model="commentsForConstruction.earthwork.comment"
                        filled
                        label="Σχόλια για τα Χωματουργικά"
                        rows="4"
                        row-height="10"
                        :readonly="readOnly"
                        :clearable="!readOnly"
                        class="field-comment"
                    ></v-textarea>
                </div>
                <div v-if="!shouldRestFieldsBeDisabled" class="comments-row-wrapper">
                    <div class="comments-selections-blowing">
                        <h4>Εμφύσηση</h4>
                        <v-select
                            v-model="commentsForConstruction.blowing.option"
                            :items="blowingOptions"
                            item-value="value"
                            item-text="name"
                            label="Είδος Outdoor Ίνας"
                            outlined
                            class="field status"
                        ></v-select>
                    </div>
                    <v-textarea
                        v-if="commentsForConstruction?.blowing?.option !== 'COMPLETED'"
                        v-model="commentsForConstruction.blowing.comment"
                        filled
                        label="Σχόλια για την Εμφύσηση"
                        rows="4"
                        row-height="10"
                        :readonly="readOnly"
                        :clearable="!readOnly"
                        class="field-comment"
                    ></v-textarea>
                </div>
                <div v-if="!shouldRestFieldsBeDisabled" class="comments-row-wrapper">
                    <div class="comments-selections-earthwork">
                        <h4>Κατασκευή</h4>
                        <v-select
                            v-model="commentsForConstruction.construction.option"
                            :items="constructionOptions"
                            item-value="value"
                            item-text="name"
                            label="Είδος Όδευσης Floor Boxes από"
                            outlined
                            class="field status"
                        ></v-select>
                        <div class="rating-wrapper">
                            <span class="rating-text">
                                Βαθμονόμιση Δυσκολίας
                            </span>
                            <v-rating
                                v-model="commentsForConstruction.construction.rating"
                                class="rating"
                                :readonly="readOnly"
                                :clearable="!readOnly"
                            >
                                <template v-slot:item="props">
                                    <div class="rating-icon-wrapper">
                                        <v-icon
                                            :color="props.isFilled ? hardnessColors[props.index] : 'grey lighten-1'"
                                            large
                                            class="rating-icon"
                                            @click="props.click"
                                        >
                                            {{ props.isFilled ? 'mdi-star-circle' : 'mdi-star-circle-outline' }}
                                        </v-icon>
                                        <span v-if="props.index === 0" class="rating-text">
                                            Έυκολο
                                        </span>
                                        <span v-if="props.index === hardnessColors.length - 1" class="rating-text">
                                            Δύσκολο
                                        </span>
                                    </div>
                                </template>
                            </v-rating>
                        </div>
                    </div>
                    <v-textarea
                        v-model="commentsForConstruction.construction.comment"
                        filled
                        label="Σχόλια για τα Κατασκευή"
                        rows="4"
                        row-height="10"
                        :readonly="readOnly"
                        :clearable="!readOnly"
                        class="field-comment"
                    ></v-textarea>
                </div>
                <div class = "autopsy-sent-wrapper">
                    <v-menu
                        v-if="!shouldRestFieldsBeDisabled"
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        left
                        offset-y
                        min-width="300"
                        class="filter-field autopsy-sent"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="sentAt"
                                class="as-built-date"
                                label="Απεστάλη στον πάροχο"
                                prepend-icon="mdi-calendar"
                                readonly
                                clearable
                                @click:clear="localAutopsy.sentAt = null"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="sentAt"
                            class="sent-at-picker"
                            color="#0047AB"
                            locale="el"
                            :disabled="readOnly"
                            @input="() => { menu2 = false }"
                        ></v-date-picker>
                    </v-menu>
                    <custom-checkbox
                        v-if="config.manualOverrideConstruction &&
                            ((config.manualOverrideConstruction.includes('ROLE_ADMIN') && this.isAdmin) ||
                                (config.manualOverrideConstruction.includes('ROLE_COORDINATOR') && this.isCoordinator)) &&
                            !localAutopsy.nextStepsAt"
                        :readOnly="readOnly"
                        :label="'Χειροκίνητη Έγκριση Κατασκευής'"
                        :color="'green'"
                        change-back
                        :value="!!localAutopsy.nextStepsAt"
                        @check-value-change="nextStepsAtManualOverride"
                    />
                    <div v-if="localAutopsy.nextStepsAt" class="assignment-next-steps">
                        <h5>Ημερομηνία Έγκρισης Κατασκευής:</h5> {{ getGreekDatetime(localAutopsy.nextStepsAt) }}
                    </div>
                </div>
            </v-card>
            <div v-if="canEdit" class="submit-button-wrapper">
                <v-btn class="mx-2 white--text" :disabled="shouldDisableSubmit" :loading="loading" large color="black" @click="onSubmit">
                    ΥΠΟΒΟΛΗ
                </v-btn>
            </div>
            <waiting-message v-if="waitingMessage" :waiting-message="waitingMessage" />
        </v-form>
        <alert class="alert" :show-alert="showAlert" :message="message" :type="type" />
    </v-container>
</template>

<script>
    import assignmentService from '@/services/assignment'
    import ImageSection from '@/components/ImageSection'
    import FileSection from '@/components/FileSection'
    import Alert from '@/components/Alert'
    import geolocation from '@/utils/geolocation'
    import momentTimezone from 'moment-timezone'
    import FloorStructure from '@/components/FloorStructure'
    import FormToolbar from '@/components/FormToolbar'
    import Comments from '@/components/Comments'
    import CustomDatetime from '@/components/CustomDatetime'
    import CustomCheckbox from '@/components/CustomCheckBox'
    import OpticalPath from '@/components/OpticalPath'
    import ProdesmeusiMaterials from '@/components/ProdesmeusiMaterials'
    import PdfViewer from '@/components/PdfViewer'
    import uploadService from '@/services/upload'
    import axios from 'axios'
    import WaitingMessage from '@/components/WaitingMessage.vue'
    const HETZNER_API_STORAGE_URL = process.env.VUE_APP_HETZNER_API_STORAGE_URL

    export default {
        name: 'AutopsyTab',
        components: { Alert, PdfViewer, ImageSection, WaitingMessage, FormToolbar, FloorStructure, Comments, CustomDatetime, CustomCheckbox, OpticalPath, ProdesmeusiMaterials, FileSection },
        watch: {
            assignment: {
                handler(newVal, oldVal) {
                    this.resetForm()
                }
            },
            'localAutopsy.subStatus': {
                handler(newVal, oldVal) {
                    this.handleStatusBasedOnSubStatus(newVal)
                },
                immediate: true
            },
            'localAutopsy.status': {
                handler(newVal, oldVal) {
                    if (newVal === 'STARTED') {
                        this.disableSubStatus = false
                    } else {
                        delete this.localAutopsy.subStatus
                        this.disableSubStatus = true
                    }
                }
            }
        },
        props: {
            assignment: {
                type: Object,
                required: true
            },
            currentUser: {
                type: Object,
                default: () => { return {} },
                required: true
            },
            canEdit: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            userRoles() {
                return this.currentUser?.roles?.map(role => role.role) || []
            },
            isCancelled() {
                return this.localAutopsy?.status === 'CANCELLED'
            },
            shouldDisableSubmit() {
                if (this.isCancelled) {
                    return !(this.editMode && (this.localAutopsy.comments || (this.newComment && this.newComment.length > 0)) && this.localAutopsy.appointmentDate)
                } else {
                    return !(this.editMode && this.localAutopsy.status && this.localAutopsy.appointmentDate)
                }
            },
            shouldRestFieldsBeDisabled() {
                return (!this.localAutopsy.appointmentDate || this.isCancelled) && !this.isAdmin
            },
            config() {
                return this.$store.getters.getConfig || {}
            },
            availableFloors() {
                return this.config?.buildingFloors || []
            },
            theming() {
                return this.$store.getters.getTheming || {}
            },
            statuses() {
                return this.config?.autopsy?.statuses || []
            },
            subStatuses() {
                return this.config?.autopsy?.subStatuses || []
            },
            earthworkOptions() {
                return this.config?.autopsy?.earthworkOptions || []
            },
            constructionOptions() {
                return this.config?.autopsy?.constructionOptions || []
            },
            blowingOptions() {
                return this.config?.autopsy?.blowingOptions || []
            },
            pdfUrl() {
                if (!this.localAutopsy.pdfFileUrl) {
                    return ''
                }
                if (this.isUrl(this.localAutopsy.pdfFileUrl)) {
                    return this.localAutopsy.pdfFileUrl
                }
                return this.hetznerApiHost + '/' + this.localAutopsy.pdfFileUrl
            }
        },
        data: () => {
            return {
                localAutopsy: {
                    description: null,
                    geolocation: null,
                    photos: [],
                    files: [],
                    docPhotos: [],
                    coordsPhotos: [],
                    status: null
                },
                hetznerApiHost: HETZNER_API_STORAGE_URL,
                hardnessColors: ['#094A25', '#0C6B37', '#F8B324', '#EB442C', '#BC2023'],
                commentsForConstruction: {
                    earthwork: {},
                    blowing: {},
                    construction: {}
                },
                videoUrl: null,
                showAlert: false,
                selectedPhotos: 0,
                smartReadiness: false,
                secondTimeSmartReadiness: false,
                sentAt: null,
                message: null,
                disableSubStatus: true,
                disableStatus: false,
                newComment: null,
                type: null,
                menu2: false,
                loading: false,
                mode: null,
                dialog: false,
                dialog2: false,
                dialog3: false,
                readOnly: false,
                clearable: true,
                floorStructure: {},
                rules: [
                    v => !!v || 'Το πεδίο είναι υποχρεωτικό'
                ],
                clientFloor: null,
                editMode: false,
                prodesmeusiFile: null,
                pdfFile: null,
                uploadLoader: false,
                waitingMessage: null
            }
        },
        created() {
            this.mode = this.$route.params.mode
            if (this.mode === 'edit') {
                this.readOnly = true
                this.clearable = false
            }
            this.assignmentId = this.$route.params.assignmentId
        },
        mounted() {
            this.resetForm()
        },
        methods: {
            nextStepsAtManualOverride(e) {
                this.localAutopsy.nextStepsAtManualOverride = e
            },
            isUrl(str) {
                try {
                    const url = new URL(str)
                    return url.protocol === 'http:' || url.protocol === 'https:'
                } catch {
                    return false
                }
            },
            onVideoOpenClick() {
                window.open(this.videoUrl, '_blank')
            },
            downloadFile(file) {
                var path = require('path')
                let fileUrl
                if (this.isUrl(file)) {
                    fileUrl = file
                } else {
                    fileUrl = HETZNER_API_STORAGE_URL + '/' + file
                }
                var name = path.basename(fileUrl)
                return axios
                    .get(fileUrl, {
                        headers: {
                            'Cache-Control': 'no-cache',
                            'Pragma': 'no-cache'
                        },
                        responseType: 'blob'
                    })
                    .then(response => {
                        const blob = response.data
                        const link = document.createElement('a')
                        link.href = URL.createObjectURL(blob)
                        link.download = name
                        link.click()
                    })
                    .catch(error => {
                        console.error(`Error fetching ${file}:`, error)
                    })
            },
            handleStatusBasedOnSubStatus(subStatus) {
                switch (subStatus) {
                case 'YES': this.localAutopsy.status = 'COMPLETED'; this.disableStatus = true; break
                case 'RESCHEDULED': this.localAutopsy.status = 'OPEN'; break
                case 'NO': this.localAutopsy.status = 'FOR_CANCELLING'; break
                case 'CONSTRUCTED': this.localAutopsy.status = 'FOR_CANCELLING'; break
                case 'WRONG_ADDRESS': this.localAutopsy.status = 'FOR_CANCELLING'; break
                case 'OUT_OF_COMMERCIAL_AVAILABILITY': this.localAutopsy.status = 'FOR_CANCELLING'; break
                }
            },
            onSmartReadinessChange(e) {
                this.smartReadiness = e
            },
            onSecondTimeSmartReadinessChange(e) {
                this.secondTimeSmartReadiness = !e
            },
            appointmentDateSelected(datetime) {
                this.$set(this.localAutopsy, 'appointmentDate', momentTimezone(datetime).tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString())
            },
            onNewComment(e) {
                this.newComment = e
            },
            onUploadPhotoError(message) {
                this.setAlert(message, 'error')
            },
            onPhotoSelection(selectedPhotos) {
                this.selectedPhotos = selectedPhotos.length
            },
            // onDocPhotoSelection(selectedPhotos) {
            //     this.selectedDocPhotos = selectedPhotos.length
            // },
            // onCoordsPhotoSelection(selectedPhotos) {
            //     this.selectedCoordsPhotos = selectedPhotos.length
            // },
            getGreekDatetime(utcDateTime) {
                return momentTimezone(utcDateTime).utc().tz('Europe/Athens').format('YYYY-MM-DD HH:mm').toString()
            },
            tabSelect(tab) {
                this.selectedTab = tab
            },
            switchEditMode(editMode) {
                if (!this.canEdit) {
                    return
                }
                this.resetForm()
                if (editMode) {
                    this.readOnly = false
                    this.clearable = true
                    this.editMode = true
                } else {
                    this.readOnly = true
                    this.clearable = false
                    this.editMode = false
                }
            },
            onFloorStructureSubmit(e) {
                this.localAutopsy.floorStructure = e
                this.localAutopsy = { ...this.localAutopsy }
                this.dialog = false
            },
            resetForm() {
                this.localAutopsy = this.assignment.autopsy ? { ...this.assignment.autopsy } : {}
                this.clientFloor = this.assignment.clientFloor
                this.sentAt = this.localAutopsy.sentAt ? this.getDateFormated(this.localAutopsy.sentAt) : null
                this.smartReadiness = this.assignment.smartReadiness
                this.secondTimeSmartReadiness = this.assignment.secondTimeSmartReadiness
                if (this.localAutopsy.commentsForConstruction) {
                    this.commentsForConstruction = this.localAutopsy.commentsForConstruction
                }
                if (this.localAutopsy.videos?.length > 0) {
                    this.videoUrl = this.localAutopsy.videos[0]
                }
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            getDateFormated(date) {
                return momentTimezone(date).tz('Europe/Athens').format('YYYY-MM-DD').toString()
            },
            processCommentsForConstruction() {
                for (let comment in this.commentsForConstruction) {
                    if (this.commentsForConstruction[comment].option === 'COMPLETED') {
                        delete this.commentsForConstruction[comment].comment
                        delete this.commentsForConstruction[comment].rating
                    }
                }
            },
            isValidUrl(str) {
                const pattern = /^(https?:\/\/)[\w.-]+(\.[\w.-]+)+[/#?]?.*$/i
                return pattern.test(str)
            },
            async editAssignment() {
                this.loading = true
                const coords = await geolocation.getCoordinates()
                if (!this.localAutopsy.photos) {
                    this.localAutopsy.photos = []
                }
                if (!this.localAutopsy.files) {
                    this.localAutopsy.files = []
                }
                if (!this.localAutopsy.docPhotos) {
                    this.localAutopsy.docPhotos = []
                }
                if (!this.localAutopsy.coordsPhotos) {
                    this.localAutopsy.coordsPhotos = []
                }
                this.waitingMessage = 'Ανέβασμα Αρχείων...'
                if (this.isAdminOrCompanyCoordinator) {
                    try {
                        const deletedPhotos = await this.$refs['image-section'].deleteUploadedPhotos()
                        this.localAutopsy.photos = deletedPhotos ? this.localAutopsy.photos.filter(photo => !deletedPhotos.includes(photo)) : [ ...this.localAutopsy.photos ]
                    } catch (error) {
                        this.setAlert(error.message, 'error')
                        this.loading = false
                        return
                    }
                }
                try {
                    const uploadedPhotos = await this.$refs['image-section'].uploadPhotos()
                    this.localAutopsy.photos = uploadedPhotos ? this.localAutopsy.photos.concat(uploadedPhotos) : [ ...this.localAutopsy.photos ]
                    if (this.pdfFile) {
                        this.localAutopsy.pdfFileUrl = await this.uploadPdfFile()
                    }
                    const uploadedFiles = await this.$refs['file-section'].uploadSelectedFiles()
                    this.localAutopsy.files = uploadedFiles ? this.localAutopsy.files.concat(uploadedFiles) : [ ...this.localAutopsy.files ]
                    // const uploadedDocPhotos = await this.$refs['image-section2'].uploadPhotos()
                    // this.localAutopsy.docPhotos = uploadedDocPhotos ? this.localAutopsy.docPhotos.concat(uploadedDocPhotos) : [ ...this.localAutopsy.docPhotos ]
                    // const uploadedCoordsPhotos = await this.$refs['image-section3'].uploadPhotos()
                    // this.localAutopsy.coordsPhotos = uploadedCoordsPhotos ? this.localAutopsy.coordsPhotos.concat(uploadedCoordsPhotos) : [ ...this.localAutopsy.coordsPhotos ]
                } catch (error) {
                    this.waitingMessage = null
                    this.setAlert(error.message, 'error')
                    this.loading = false
                    return
                }
                if (this.sentAt) {
                    this.localAutopsy.sentAt = momentTimezone(this.sentAt).tz('Europe/Athens').startOf('day').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
                }
                if (this.videoUrl) {
                    if (!this.videoUrl.startsWith('https://')) {
                        this.videoUrl = 'https://' + this.videoUrl
                    }
                    if (this.isValidUrl(this.videoUrl)) {
                        this.localAutopsy.videos = []
                        this.localAutopsy.videos.push(this.videoUrl)
                    } else {
                        this.videoUrl = null
                    }
                } else {
                    this.localAutopsy.videos = null
                }
                this.processCommentsForConstruction()
                this.localAutopsy.commentsForConstruction = this.commentsForConstruction
                this.localAutopsy.newComment = this.newComment
                this.localAutopsy.geolocation = coords
                this.localAutopsy.clientFloor = this.clientFloor
                this.localAutopsy.smartReadiness = this.smartReadiness
                this.localAutopsy.secondTimeSmartReadiness = this.secondTimeSmartReadiness
                assignmentService.updateAssignmentTab('autopsy', this.assignment.id, { autopsy: this.localAutopsy }).then((response) => {
                    this.switchEditMode(false)
                    this.$refs['comments'].clear()
                    this.$emit('assignment-refresh')
                    this.setAlert('Η καταχώρηση της αυτοψίας ήταν επιτυχημένη', 'success')
                }).catch((error) => {
                    this.setAlert(error?.response?.data?.message || 'Προέκυψε κάποιο σφάλμα. Παρακαλώ επικοινωνήστε με τον Διαχειριστή', 'error')
                }).finally(() => {
                    this.loading = false
                    this.waitingMessage = null
                })
            },

            async onSubmit() {
                if (this.mode === 'edit') {
                    this.editAssignment()
                }
            },
            uploadProdesmeusiFile() {
                this.uploadLoader = true
                let formData = new FormData()
                formData.append('file', this.prodesmeusiFile)
                assignmentService.importProdesmeusi(this.assignment.id, formData).then(resp => {
                    this.prodesmeusiFile = null
                    this.setAlert('Η προδέσμευση ανέβηκε επιτυχώς', 'success')
                    this.uploadLoader = false
                    this.$emit('assignment-refresh')
                }).catch((error) => {
                    this.setAlert(error.response.data.message, 'error')
                    this.uploadLoader = false
                })
            },
            async uploadPdfFile() {
                let formData = new FormData()
                formData.append('file', this.pdfFile)
                const response = await uploadService.uploadFile(this.assignment.sr + '/autopsy', formData)
                if (response.status === 200) {
                    this.pdfFile = null
                    return response.data.content
                }
                return null
            }
        }

    }
</script>
<style scoped>
.autopsy-sent-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-evenly;
}

.as-built-date, .assignment-next-steps {
    max-width: 300px;
    min-width: 250px;
}

.comments-selections-earthwork {
    display: flex;
    margin-top: 1rem;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
}

.comments-selections-blowing {
    display: flex;
    margin-top: 1rem;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
}

.prodesmeusi-file-input, .pdf-file-input {
    display: flex;
    min-width: 300px;
    align-items: center;
}
.rating-icon {
    padding-bottom: 0;
    padding-top: 0;
}
.rating-text {
    font-size: 0.8rem;
    color:gray;
}
.rating-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.5rem;
}
.prodesmeusi-buttons-wrapper {
    margin-bottom: 2rem;
    display: flex;
    flex-wrap: wrap;
}
.form-group-fields {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
}

.field-comment {
    max-height: 130px;
}

.body-label {
    color: rgba(0, 0, 0, 0.6);
}
.body-editor {
    margin-bottom: 2vh;
}

.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
}
.rating {
    display: flex;
}

.field.status {
    min-width: 280px;
    max-width: 35%;
    align-self: center;
}

.appointment-datetime {
    min-width: 200px;
    max-width: 20%;
}

.photo-preview-wrapper {
    display: flex;
    flex-wrap: wrap;
}

.first-row-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    align-items: first baseline;
}

.second-row-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-items: first baseline;
    margin-bottom: 1rem;
}

.comments-row-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    flex-direction: column;
    border: solid 1px var(--cards-and-tables-text-color);
    padding: 1rem;
    padding-top: 0;
    border-radius: 5px;
    margin-bottom: 0.5rem;
}

.rating-icon-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.v-card {
    padding: 0.8rem;
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}

.client-floor {
    max-width: 200px;
    margin: 1rem;
}

.alert {
    width: 100%;
}

.button-to-display {
    margin: 1rem;
}

</style>
